import React, { useState, useEffect } from 'react';
import { Col, Row, Image } from 'react-bootstrap';
import styles from './manageUsers.module.scss';
// import AddUser from './addUsers';
import AddNewMembersModal from './addUsers';
import { getAllUsers } from '../../../services/util/userManagement';
import { deleteUser } from '../../../services/util/userManagement';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import CustomNavbar from '../customNavbar';
import { CustomSearch } from '../../shared/customSearch';
import { CustomButton } from '../../shared/customButton';
import { CustomConfirmationModal } from '../../shared/customConfirmationModal';
import { CustomStatusLabel } from '../../shared/customStatusLabel';
import CSSLoader from '../../shared/cssLoader';
import { CustomIconButton } from '../../shared/customIconButton';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { resendUserInvitation } from "../../../services/util/userManagement";

const moment = require('moment');

const ManageUsers = (props) => {

    let userRolePermissions = {
        admin: [
            {
                label: 'Company Setting',
                is_enabled: true
            },
            {
                label: 'Billing',
                is_enabled: true
            },
            {
                label: 'Company Analytics',
                is_enabled: true
            },
            {
                label: 'Create/Edit Pipelines',
                is_enabled: true
            },
            {
                label: 'View Pipelines',
                is_enabled: true
            },
            {
                label: 'Disable Pipeline',
                is_enabled: true
            },
            {
                label: 'Add/Edit User',
                is_enabled: true
            },
            {
                label: 'View User',
                is_enabled: true
            },
            {
                label: 'Delete User',
                is_enabled: true
            },
            {
                label: 'Review CVs',
                is_enabled: true
            },
            {
                label: 'Interviews',
                is_enabled: true
            },
            {
                label: 'External Assignment',
                is_enabled: true
            },
            {
                label: 'Custom Evaluations',
                is_enabled: true
            },
            {
                label: 'One Way Interview',
                is_enabled: true
            },
            {
                label: 'Reference Check',
                is_enabled: true
            },
            {
                label: 'Interview Scheduling',
                is_enabled: true
            },
            {
                label: 'Templates',
                is_enabled: true
            },
            {
                label: 'Job offer Approvals',
                is_enabled: true
            },
            {
                label: 'Job offer Handling',
                is_enabled: true
            },
            {
                label: 'Candidate Onboarding',
                is_enabled: true
            },
            {
                label: 'View Candidate Profile',
                is_enabled: true
            },
            {
                label: 'Delete Candidate Profile',
                is_enabled: true
            },
        ],
        recruiter: [
            {
                label: 'Company Setting',
                is_enabled: false
            },
            {
                label: 'Billing',
                is_enabled: false
            },
            {
                label: 'Company Analytics',
                is_enabled: true
            },
            {
                label: 'Create/Edit Pipelines',
                is_enabled: true
            },
            {
                label: 'View Pipelines',
                is_enabled: true
            },
            {
                label: 'Disable Pipeline',
                is_enabled: true
            },
            {
                label: 'Add/Edit User',
                is_enabled: false
            },
            {
                label: 'View User',
                is_enabled: false
            },
            {
                label: 'Delete User',
                is_enabled: false
            },
            {
                label: 'Review CVs',
                is_enabled: true
            },
            {
                label: 'Interviews',
                is_enabled: true
            },
            {
                label: 'External Assignment',
                is_enabled: true
            },
            {
                label: 'Custom Evaluations',
                is_enabled: true
            },
            {
                label: 'One Way Interview',
                is_enabled: true
            },
            {
                label: 'Reference Check',
                is_enabled: true
            },
            {
                label: 'Interview Scheduling',
                is_enabled: true
            },
            {
                label: 'Templates',
                is_enabled: true
            },
            {
                label: 'Job offer Approvals',
                is_enabled: true
            },
            {
                label: 'Job offer Handling',
                is_enabled: true
            },
            {
                label: 'Candidate Onboarding',
                is_enabled: true
            },
            {
                label: 'View Candidate Profile',
                is_enabled: true
            },
            {
                label: 'Delete Candidate Profile',
                is_enabled: false
            },
        ],
        reviewer: [
            {
                label: 'Company Setting',
                is_enabled: false
            },
            {
                label: 'Billing',
                is_enabled: false
            },
            {
                label: 'Company Analytics',
                is_enabled: false
            },
            {
                label: 'Create/Edit Pipelines',
                is_enabled: false
            },
            {
                label: 'View Pipelines',
                is_enabled: false
            },
            {
                label: 'Disable Pipeline',
                is_enabled: false
            },
            {
                label: 'Add/Edit User',
                is_enabled: false
            },
            {
                label: 'View User',
                is_enabled: false
            },
            {
                label: 'Delete User',
                is_enabled: false
            },
            {
                label: 'Review CVs',
                is_enabled: true
            },
            {
                label: 'Interviews',
                is_enabled: true
            },
            {
                label: 'External Assignment',
                is_enabled: true
            },
            {
                label: 'Custom Evaluations',
                is_enabled: true
            },
            {
                label: 'One Way Interview',
                is_enabled: true
            },
            {
                label: 'Reference Check',
                is_enabled: true
            },
            {
                label: 'Interview Scheduling',
                is_enabled: false
            },
            {
                label: 'Templates',
                is_enabled: true
            },
            {
                label: 'Job offer Approvals',
                is_enabled: true
            },
            {
                label: 'Job offer Handling',
                is_enabled: false
            },
            {
                label: 'Candidate Onboarding',
                is_enabled: false
            },
            {
                label: 'View Candidate Profile',
                is_enabled: true
            },
            {
                label: 'Delete Candidate Profile',
                is_enabled: false
            },
        ],

    }


    let [sideBarOpen, setSideBar] = useState(false);
    let [isLoading, setLoading] = useState(false);
    let [isPageDataLoading, setIsPageDataLoading] = useState(false);
    let [sideBarType, setSideBarType] = useState(1);
    let [value, setArrayValues] = useState([]);
    let [editUserValues, setEditUserValues] = useState();
    let [isURLLoading, setURLLoading] = useState(false);
    let [modal, setModal] = useState({
        isOpen: false,
        userId: ''
    });
    let [filteredValues, setFilteredValues] = useState([]);
    let [noSearchData, setNoSearchData] = useState(false);
    const [showModal, setShowModal] = useState(false);
    let [showEditModal, setShowEditModal] = useState(false);
    const breadcrumb = [
        {
            pathaddress: '/app/company/users',
            pathname: 'Manage Users',
            isActive: false,
            key: 1 + 'manage-users'
        }
    ]

    const breacrumbText = 'Add everyone who involve in the hiring process. Including HR team, Interviewers, technical reviewers and decision makers. Use roles to enable relevant permissions.'

    //resend user invitation
    const handleResendInvite = (userId) => {
        resendUserInvitation(
            userId
        );
    };


    // functions
    const handleCloseAddNewMembersModal = () => setShowModal(false);
    const handleShowAddNewMembersModal = () => {
        setShowModal(true);
    }

    const handleCloseEditModal = () => setShowEditModal(false);
    const handleShowEditModal = (user) => {
        setEditUserValues({
            email: user.user_email,
            userRole: user.user_role,
            userID: user.user_id
        })
        setShowEditModal(true);
    }

    function openSideBar(value) {
        setSideBarType(value)
        setSideBar(true)
    }

    function closeSideBar() {
        setSideBar(false)
    }

    function reloadUsers() {
        setSideBar(false)
        getAllUsersDetails();
    }

    // function editUserDetails(value) {
    //     setEditUserValues(value)

    // }

    function setModelOpenState(value) {
        setModal((prevState) => ({
            ...prevState,
            isOpen: value
        }))
    }

    function setModelState(open, user_id) {
        setModal((prevState) => ({
            ...prevState,
            isOpen: open,
            userId: user_id
        }))
    }

    function searchValus(searchValue) {
        let searchVal = searchValue.toLowerCase();
        const filtered = value.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
        setFilteredValues(filtered);
        if (filtered.length === 0) {
            setNoSearchData(true)
        }
    }



    // modal.userId
    const deleteUserDetails = async () => {
        setLoading(true)
        let respond = await deleteUser(modal.userId)
        if (respond.success === true) {
            setLoading(false)
            setModelOpenState(false)
            getAllUsersDetails();
        } else {
            setLoading(false)
            setModelOpenState(false)
        }
    }

    const getAllUsersDetails = async () => {
        setIsPageDataLoading(true)
        let respond = await getAllUsers();
        if (respond.success === true) {
            let resultset = respond.data;
            let resultObj = [];
            //resultset structure modify to add material table
            resultset.forEach(element => {
                //add all permissions activated in to array
                let userRolesArray = [];
                if (element.user_id.permissions.user_role === 0) {
                    userRolesArray.push(element.user_id.first_name + ' ' + element.user_id.last_name);
                } else {
                    if (element.user_id.permissions.access_levels.cv_review.is_enabled === true) {
                        userRolesArray.push('Review CVs');
                    }
                    if (element.user_id.permissions.access_levels.interviews.is_enabled === true) {
                        userRolesArray.push('Interviews');
                    }
                    if (element.user_id.permissions.access_levels.external_assessment_review.is_enabled === true) {
                        userRolesArray.push('External Assignment Review');
                    }
                    if (element.user_id.permissions.access_levels.approvals.is_enabled === true) {
                        userRolesArray.push('Approvals');
                    }
                    if (element.user_id.permissions.access_levels.hiring_pipeline.actions.edit_pipeline === true) {
                        userRolesArray.push('Create/Edit pipelines');
                    }
                    if (element.user_id.permissions.access_levels.hiring_pipeline.actions.delete_pipeline === true) {
                        userRolesArray.push('Delete pipeline');
                    }
                    if (element.user_id.permissions.access_levels.hiring_pipeline.actions.view_pipeline === true) {
                        userRolesArray.push('View pipeline');
                    }
                    if (element.user_id.permissions.access_levels.manage_users.actions.remove_users === true) {
                        userRolesArray.push('Remove Users');
                    }
                    if (element.user_id.permissions.access_levels.manage_users.actions.edit_users === true) {
                        userRolesArray.push('Add/Edit Users');
                    }
                    if (element.user_id.permissions.access_levels.manage_users.actions.view_users === true) {
                        userRolesArray.push('View Users');
                    }
                    if (element.user_id.permissions.access_levels.schedule_interviews.actions.schedule_interviews === true) {
                        userRolesArray.push('Schedule Interviews');
                    }
                    if (element.user_id.permissions.access_levels.schedule_interviews.actions.view_pending_interviews === true) {
                        userRolesArray.push('View Schedules');
                    }
                    if (element.user_id.permissions.access_levels.billing.actions.billing_actions === true) {
                        userRolesArray.push('Billing Actions');
                    }
                    if (element.user_id.permissions.access_levels.billing.actions.view_billing_details === true) {
                        userRolesArray.push('View Billing');
                    }
                    if (element.user_id.permissions.access_levels.company_settings.actions.edit_settings === true) {
                        userRolesArray.push('Edit Settings');
                    }
                    if (element.user_id.permissions.access_levels.company_settings.actions.view_settings === true) {
                        userRolesArray.push('View Settings');
                    }
                    if (element.user_id.permissions.access_levels.analytics.actions.view_analytics_details === true) {
                        userRolesArray.push('View Analytics');
                    }
                    if (element.user_id.permissions.access_levels.offer_handling.actions.view_offers === true) {
                        userRolesArray.push('View Offers');
                    }
                    if (element.user_id.permissions.access_levels.offer_handling.actions.edit_offers === true) {
                        userRolesArray.push('Edit Offers');
                    }
                    if (element.user_id.permissions.access_levels.onboarding.actions.view_onboards === true) {
                        userRolesArray.push('View Pending Onboardings');
                    }
                    if (element.user_id.permissions.access_levels.onboarding.actions.edit_onboards === true) {
                        userRolesArray.push('Edit Pending Onboardings');
                    }
                    if (element.user_id.permissions.access_levels.quiz_templates.actions.view_quiz_templates === true) {
                        userRolesArray.push('View Quiz Templates');
                    }
                    if (element.user_id.permissions.access_levels.quiz_templates.actions.edit_quiz_templates === true) {
                        userRolesArray.push('Edit Quiz Templates');
                    }
                    if (element.user_id.permissions.access_levels.quiz_templates.actions.delete_quiz_templates === true) {
                        userRolesArray.push('Delete Quiz Templates');
                    }
                    if (element.user_id.permissions.access_levels.reference_check_review.is_enabled === true) {
                        userRolesArray.push('Reference Check Review');
                    }
                    if (element.user_id.permissions.access_levels.custom_evaluation_review.is_enabled === true) {
                        userRolesArray.push('Custom Evaluation Review');
                    }
                }

                //create result object 
                let result = {
                    user_email: element.user_id.email,
                    user_name: element.user_id.signup_completed ? element.user_id.first_name + ' ' + element.user_id.last_name : 'Pending invite',
                    user_permission_roles: userRolesArray,
                    user_details_json: element.user_id,
                    user_role: element.user_id.permissions.user_role,
                    user_id: element.user_id._id,
                    number_of_assigned_cv_reviews: (element.assigned_tasks.cv_reviews).length,
                    number_of_assigned_interviewes: (element.assigned_tasks.interviews).length,
                    activated: element.user_id.activated,
                    position: element.user_id.position,
                    last_login: element.last_login ? moment(element.last_login).format('DD MMM YYYY, HH:mmA') : '-',
                };
                resultObj.push(result);
            });
            setFilteredValues(resultObj);
            setArrayValues(resultObj);
            setIsPageDataLoading(false)
        } else {
            setIsPageDataLoading(false)
        }
    }

    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filteredValues.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(filteredValues.length / itemsPerPage);

    useEffect(() => {
        getAllUsersDetails();
    }, []);

    useEffect(() => {
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
    }, [])

    return (
        <div>
            <Helmet>
                <title>Manage Users | HireTrace</title>
            </Helmet>

            {/* Modal View Start */}
            {
                showModal === true ?
                    <AddNewMembersModal show={showModal} isCreateMode={true} userDetails={{}} handleClose={handleCloseAddNewMembersModal} reloadUsers={reloadUsers} userRolePermissions={userRolePermissions} />
                    : null
            }

            {/* Modal View End */}

            {/* Edit Modal View Start */}
            {
                showEditModal === true ?
                    <AddNewMembersModal show={showEditModal} isCreateMode={false} userDetails={editUserValues} handleClose={handleCloseEditModal} reloadUsers={reloadUsers} userRolePermissions={userRolePermissions} />
                    // <EditMembersModal handleClose={handleCloseEditModal} showEditModal={showEditModal} reloadUsers={reloadUsers} editUserValues={editUserValues} userRolePermissions={userRolePermissions} />
                    : null
            }

            {/* Edit Stage Modal View End */}


            {/* user Delete alert Start */}
            <CustomConfirmationModal
                show={modal.isOpen}
                cancelIconclick={() => setModelOpenState(false)}
                confirmationType='danger'
                onSecondaryBtnClick={() => setModelOpenState(false)}
                onPrimaryBtnClick={deleteUserDetails}
                isSecondaryBtnDisabled={isLoading === true ? true : false}
                isPrimaryBtnDisabled={isLoading === true ? true : false}
                primaryBtnBackSideIcon={isLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                confirmationMessage="You will not be able to recover this user!"
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                secondaryBtnId="adminPanel_manageUsers_addUsers_userDelete_userDeletePopupCancelBtnId"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, delete it!"
                primaryBtnId="adminPanel_manageUsers_addUsers_userDelete_userDeletePopupYesBtnId"
            />
            {/* user Delete alert End */}

            {isPageDataLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb}  breacrumbText= {breacrumbText}/>
                        <Col className={styles.controlsBarBox}>
                            <div>
                                <Row className='d-flex'>
                                    <Col sm={9} className="mb-1">
                                        <CustomSearch
                                            placeholder="Search Users"
                                            handleOnChange={(e) => searchValus(e.target.value)}
                                            id="manage_users_search_bar"
                                        />
                                    </Col>
                                    <Col sm={3} className="mb-1">
                                        <CustomButton
                                            buttonType="button"
                                            label="Add New User"
                                            type="primaryBtn"
                                            id="adminPanel_manageUsers_addNewUser_addNewUserBtnId"
                                            frontIcon={
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10.0001 4.16675V15.8334M4.16675 10.0001H15.8334" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }
                                            handleClick={handleShowAddNewMembersModal}
                                            disabled={
                                                props.permissions.actions.edit_users === false ? true : false
                                            }
                                            toolTipId={props.permissions.actions.edit_users === false && "manage_users_permission_error_tool_tip_id"}
                                            toolTip={props.permissions.actions.edit_users === false && "Permission Denied"}
                                            showToolTip={props.permissions.actions.edit_users === false ? true : false}

                                        />
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </div>


                    <div className={styles.tableBodyContainer}>
                        {
                            ((filteredValues.length === 0) && (isPageDataLoading === false)) ?
                                (<div>

                                    {noSearchData ?
                                        <Col>
                                            <p className={styles.noDataInfoMessage}>No records found for your search, Try a different keyword. </p>
                                        </Col>
                                        :
                                        <div>
                                            <Col>
                                                <p className={styles.noDataInfoMessage}>Add your Hiring Team. Follow <a href='https://hiretrace.io/documentation/getting-started/101' target="_blank">Getting Started Guideline</a>. Or Learn more
                                                    about  <a href='https://hiretrace.io/documentation/manage-users/overview' target="_blank">Manage Users</a>. </p>
                                            </Col>
                                            <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/startPipeline.svg`} fluid />
                                            </Col>
                                        </div>
                                    }


                                </div>)
                                :
                                (<div>
                                    <div className={styles.tableContainer}>
                                        <div className={styles.tableFirstRowMainHeaderDiv}>
                                            <Col sm={4} className={styles.tableDetailsMainHeaderRowLeftAligned}>
                                                <p>User Details</p>
                                            </Col>
                                            <Col sm={2} className={styles.tableDetailsMainHeaderRowLeftAligned}>
                                                <p>Status</p>
                                            </Col>
                                            <Col sm={2}>
                                                <Row className={styles.tableDetailsMainHeaderRowLeftAligned}>
                                                    <p>Role and Position</p>
                                                </Row>
                                            </Col>
                                            <Col sm={2}>
                                                <Row className={styles.tableDetailsMainHeaderRowCentered}>
                                                    <p>Last Login</p>
                                                </Row>
                                            </Col>
                                            <Col sm={2}>
                                                <Row className={styles.tableDetailsMainHeaderRowCentered}>
                                                    <p>Actions</p>
                                                </Row>
                                            </Col>
                                        </div>
                                        {filteredValues?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((users, i) => {
                                            return (
                                                <div className={i % 2 === 0 ? styles.tableRowMainDiv : styles.tableRowSecondMainDiv}>
                                                    <Col sm={4}>
                                                        <Row className={styles.tableFirstColumnData}>
                                                            <Col sm={2}>
                                                                <div className={styles.tableMainIconDiv}>
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g id="user-01">
                                                                            <path id="Icon" d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                    </svg>
                                                                </div>

                                                            </Col>
                                                            <Col sm={10}>
                                                                <Row >
                                                                    <p className={styles.tableDataTwoRowPrimary}>{users?.user_name}</p>
                                                                </Row>
                                                                <Row >
                                                                    <p className={styles.tableDataTwoRowSecondary}>{users?.user_email}</p>
                                                                </Row>
                                                            </Col>

                                                        </Row>

                                                    </Col>
                                                    <Col sm={2} className={styles.tableDataStatus} >
                                                        <CustomStatusLabel type={users.activated === true ? 'successStatus' : 'warningStatus'} label={users.activated === true ? 'Joined' : 'Invitation Pending'}></CustomStatusLabel>
                                                    </Col>
                                                    <Col sm={2}>
                                                        <Row className={styles.tableDataTwoRows}>
                                                            <Row >
                                                                <p className={styles.tableDataTwoRowPrimary}>{users.user_role === 0 ? "Admin" : users.user_role === 10 ? "Recruiter" : users.user_role === 20 ? "Reviewer" : null}</p>
                                                            </Row>
                                                            <Row >
                                                                <p className={styles.tableDataTwoRowSecondary} id="adminPanel_manageUsers_userPositionInUsersTableId">{users.position ? users.position : '-'}</p>
                                                            </Row>
                                                        </Row>

                                                    </Col>
                                                    <Col sm={2}>
                                                        <Row className={styles.tableDataCentered}>
                                                            <p className={styles.tableDataSingleRow}>{users.last_login ? users.last_login : '-'}</p>
                                                        </Row>
                                                    </Col>

                                                    <Col sm={2}>
                                                        <Row className={styles.tableDataActions}>

                                                            {/*Resend email invitation*/}

                                                            <Col sm={3}>
                                                                <div>
                                                                    {!users.activated && (
                                                                        <CustomIconButton
                                                                            toolTipId={"Resent_invitaion"}
                                                                            type="successBtn"
                                                                            showToolTip={true}
                                                                            toolTip={'Resend invitaion'}
                                                                            icon={
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                                    <g clip-path="url(#clip0_4445_4988)">
                                                                                        <path d="M5.24976 6.75003L10.4998 1.50003M5.31355 6.91406L6.62761 10.2931C6.74337 10.5907 6.80125 10.7396 6.88465 10.783C6.95695 10.8207 7.04308 10.8207 7.11542 10.7832C7.19887 10.7398 7.25693 10.591 7.37304 10.2935L10.6682 1.84962C10.773 1.58103 10.8254 1.44674 10.7968 1.36093C10.7719 1.2864 10.7134 1.22792 10.6389 1.20302C10.553 1.17435 10.4188 1.22676 10.1502 1.33158L1.70629 4.62675C1.40875 4.74286 1.25998 4.80091 1.21663 4.88437C1.17904 4.95671 1.1791 5.04284 1.21676 5.11513C1.26022 5.19854 1.40905 5.25642 1.70673 5.37218L5.08573 6.68623C5.14615 6.70973 5.17636 6.72148 5.20181 6.73963C5.22435 6.75571 5.24407 6.77543 5.26016 6.79798C5.2783 6.82342 5.29005 6.85363 5.31355 6.91406Z" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </g>
                                                                                    <defs>
                                                                                        <clipPath id="clip0_4445_4988">
                                                                                            <rect width="12" height="12" fill="white" />
                                                                                        </clipPath>
                                                                                    </defs>
                                                                                </svg>
                                                                            }
                                                                            handleClick={() => handleResendInvite(users?.user_id)}

                                                                        />
                                                                    )}

                                                                </div>
                                                            </Col>

                                                            <Col sm={3}>
                                                                <div className={styles.tableDatActionsLeftBtns}>

                                                                    {users.activated && (
                                                                        <CustomIconButton
                                                                            type="successBtn"
                                                                            id={'adminPanel_manageUsers_editBtnId'}
                                                                            icon={
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                                                                                    <g clip-path="url(#clip0_1061_43978)">
                                                                                        <path d="M6 2H3.9C3.05992 2 2.63988 2 2.31901 2.16349C2.03677 2.3073 1.8073 2.53677 1.66349 2.81901C1.5 3.13988 1.5 3.55992 1.5 4.4V8.6C1.5 9.44008 1.5 9.86012 1.66349 10.181C1.8073 10.4632 2.03677 10.6927 2.31901 10.8365C2.63988 11 3.05992 11 3.9 11H8.1C8.94008 11 9.36012 11 9.68099 10.8365C9.96323 10.6927 10.1927 10.4632 10.3365 10.181C10.5 9.86012 10.5 9.44008 10.5 8.6V6.5M4.49999 8H5.33726C5.58185 8 5.70414 8 5.81923 7.97237C5.92127 7.94787 6.01881 7.90747 6.10828 7.85264C6.2092 7.7908 6.29568 7.70432 6.46863 7.53137L11.25 2.75C11.6642 2.33579 11.6642 1.66421 11.25 1.25C10.8358 0.835786 10.1642 0.835785 9.75 1.25L4.96862 6.03137C4.79567 6.20432 4.70919 6.2908 4.64735 6.39171C4.59252 6.48119 4.55211 6.57873 4.52762 6.68077C4.49999 6.79586 4.49999 6.91815 4.49999 7.16274V8Z" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </g>
                                                                                    <defs>
                                                                                        <clipPath id="clip0_1061_43978">
                                                                                            <rect width="12" height="12" fill="white" transform="translate(0.5)" />
                                                                                        </clipPath>
                                                                                    </defs>
                                                                                </svg>
                                                                            }
                                                                            handleClick={() => handleShowEditModal(users)}
                                                                        />)}

                                                                    {!users.activated && (
                                                                        <CustomIconButton
                                                                            toolTipId={"edit_user_details"}
                                                                            type="disabledBtn"
                                                                            id={'manage_users_edit_user_icon_btn'}
                                                                            showToolTip={true}
                                                                            toolTip={'Delete this user and add again to change details'}
                                                                            icon={
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                                                                                    <g clip-path="url(#clip0_1061_43978)">
                                                                                        <path d="M6 2H3.9C3.05992 2 2.63988 2 2.31901 2.16349C2.03677 2.3073 1.8073 2.53677 1.66349 2.81901C1.5 3.13988 1.5 3.55992 1.5 4.4V8.6C1.5 9.44008 1.5 9.86012 1.66349 10.181C1.8073 10.4632 2.03677 10.6927 2.31901 10.8365C2.63988 11 3.05992 11 3.9 11H8.1C8.94008 11 9.36012 11 9.68099 10.8365C9.96323 10.6927 10.1927 10.4632 10.3365 10.181C10.5 9.86012 10.5 9.44008 10.5 8.6V6.5M4.49999 8H5.33726C5.58185 8 5.70414 8 5.81923 7.97237C5.92127 7.94787 6.01881 7.90747 6.10828 7.85264C6.2092 7.7908 6.29568 7.70432 6.46863 7.53137L11.25 2.75C11.6642 2.33579 11.6642 1.66421 11.25 1.25C10.8358 0.835786 10.1642 0.835785 9.75 1.25L4.96862 6.03137C4.79567 6.20432 4.70919 6.2908 4.64735 6.39171C4.59252 6.48119 4.55211 6.57873 4.52762 6.68077C4.49999 6.79586 4.49999 6.91815 4.49999 7.16274V8Z" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </g>
                                                                                    <defs>
                                                                                        <clipPath id="clip0_1061_43978">
                                                                                            <rect width="12" height="12" fill="white" transform="translate(0.5)" />
                                                                                        </clipPath>
                                                                                    </defs>
                                                                                </svg>
                                                                            }
                                                                        />)}
                                                                </div>
                                                            </Col>

                                                            <Col sm={3}>
                                                                <div>
                                                                    <CustomIconButton
                                                                        type="dangerBtn"
                                                                        id={'adminPanel_manageUsers_deleteBtnId'}
                                                                        icon={
                                                                            <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path id="Icon" d="M10.1667 3.4V2.92C10.1667 2.24794 10.1667 1.91191 10.0213 1.65521C9.89351 1.42942 9.68954 1.24584 9.43865 1.13079C9.15344 1 8.78007 1 8.03333 1H6.96667C6.21993 1 5.84656 1 5.56135 1.13079C5.31046 1.24584 5.10649 1.42942 4.97866 1.65521C4.83333 1.91191 4.83333 2.24794 4.83333 2.92V3.4M6.16667 6.7V9.7M8.83333 6.7V9.7M1.5 3.4H13.5M12.1667 3.4V10.12C12.1667 11.1281 12.1667 11.6321 11.9487 12.0172C11.7569 12.3559 11.451 12.6312 11.0746 12.8038C10.6468 13 10.0868 13 8.96667 13H6.03333C4.91323 13 4.35318 13 3.92535 12.8038C3.54903 12.6312 3.24307 12.3559 3.05132 12.0172C2.83333 11.6321 2.83333 11.1281 2.83333 10.12V3.4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>
                                                                        }
                                                                        handleClick={() => setModelState(true, users.user_id)}
                                                                    />
                                                                </div>
                                                            </Col>



                                                        </Row>
                                                    </Col>

                                                    <Col sm={2}>
                                                    </Col>
                                                </div>
                                            );

                                        })
                                        }
                                    </div>

                                    {filteredValues.length > 9 && isPageDataLoading === false &&
                                        <div className={styles.bottomTableDiv}>
                                            <div className={styles.bottomTableControlsWrapper}>

                                                <div className={styles.bottomTableControlsNextBtn}>
                                                    <CustomButton
                                                        id="manage_users_go_to_previous_page_btn"
                                                        label="Previous"
                                                        type="defaultSmallBtn"
                                                        handleClick={handlePreviousClick}
                                                        disabled={currentPage === 1}
                                                    />
                                                </div>
                                                <div>
                                                    <CustomButton
                                                        id="manage_users_go_to_next_page_btn"
                                                        label="Next"
                                                        type="defaultSmallBtn"
                                                        handleClick={handleNextClick}
                                                        disabled={currentPage === Math.ceil(filteredValues.length / itemsPerPage)}
                                                    />
                                                </div>

                                            </div>
                                            <div>
                                                <span className={styles.paginationInfo}>
                                                    Page {currentPage} of {totalPages}
                                                </span>
                                            </div>

                                        </div>
                                    }
                                </div>)
                        }
                    </div>
                </div>)
            }
        </div >
    )
}
export default ManageUsers;